import script from "./methods.vue?vue&type=script&setup=true&lang=js"
export * from "./methods.vue?vue&type=script&setup=true&lang=js"

import "./methods.vue?vue&type=style&index=0&id=347b6629&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347b6629"]])

export default __exports__